module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Regular.eot?8e55cf5779cb8537ce86a27c25b49788";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Regular.eot
// module id = 316
// module chunks = 0